module.exports = __webpack_public_path__ + "static/fonts/Nunito-SemiBoldItalic.6fd79fd.woff";